import React from 'react';
import { useTranslation } from 'react-i18next';
import { apps } from '../data/apps';
import AppCard from './AppCard';

const AppGrid: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section
            id="apps"
            className="scroll-mt-24 border-t border-black/[0.05] dark:border-white/[0.07]"
        >
            <div className="mx-auto max-w-6xl px-6 py-10 md:py-12">
                <h2 className="text-[1.5rem] font-bold tracking-[-0.02em] text-gray-900 md:text-[1.75rem] dark:text-white">
                    {t('showcase.title')}
                </h2>
                <p className="mt-1.5 max-w-lg text-[13px] leading-relaxed text-gray-500 [text-wrap:pretty] md:text-sm dark:text-gray-400">
                    {t('showcase.subtitle')}
                </p>

                <div className="mt-6 grid gap-4 md:mt-8 md:grid-cols-2 md:gap-5">
                    {apps.map((app, index) => (
                        <AppCard key={app.id} app={app} index={index} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AppGrid;
